import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import it from './locales/it.json';
import cs from './locales/cs.json';
import nl from './locales/nl.json';
import es from './locales/es.json';

// Mapping des codes de langue du contexte aux codes ISO
const contextToLanguageCode = {
  Français: 'fr',
  Anglais: 'en',
  Allemand: 'de',
  Italien: 'it',
  Tchèque: 'cs',
  Néerlandais: 'nl',
  Espagnol: 'es',
};

const resources = {
  en: { translation: en },
  fr: { translation: fr },
  de: { translation: de },
  it: { translation: it },
  cs: { translation: cs },
  nl: { translation: nl },
  es: { translation: es },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    react: {
      useSuspense: false,
    },
  });

export const preloadTranslation = (languageCode) => {
  switch (languageCode) {
    case 'fr':
      return import('./locales/fr.json');
    case 'en':
      return import('./locales/en.json');
    case 'de':
      return import('./locales/de.json');
    case 'it':
      return import('./locales/it.json');
    case 'cs':
      return import('./locales/cs.json');
    case 'nl':
      return import('./locales/nl.json');
    case 'es':
      return import('./locales/es.json');
    default:
      return import('./locales/en.json');
  }
};

export const getLanguageCodeFromContext = (contextLanguage) => {
  return contextToLanguageCode[contextLanguage] || 'en';
};

export const getContextFromLanguageCode = (languageCode) => {
  const entries = Object.entries(contextToLanguageCode);
  for (const [context, code] of entries) {
    if (code === languageCode) {
      return context;
    }
  }
  return 'Anglais';
};

export default i18n;
